var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { inject, observer } from 'mobx-react';
import moment from "moment";
import { createForm } from "rc-form";
import { AccountBusiness } from '@business/account/login';
import classnames from 'classnames';
import { getUrlParams } from '@common/utils/url';
import './index.less';
import { Loader } from 'oned';
import { sendAmplitude_Otp } from '@common/utils';
import { AmplitudeEventName } from '@common/enums/base';
var defaultValue = {
    errorMsg: '',
    successMsg: '',
    otpValue: ['', '', '', '', '', ''],
    phoneNumber: '',
    residentId: '',
    submitting: false,
    resendOtpTime: 0,
    isLoading: false,
    isPhoneEnc: '',
    eventId: ''
};
var VerifyOTP = /** @class */ (function (_super) {
    __extends(VerifyOTP, _super);
    function VerifyOTP(props) {
        var _this = _super.call(this, props) || this;
        _this.input0 = null;
        _this.input1 = null;
        _this.input2 = null;
        _this.input3 = null;
        _this.input4 = null;
        _this.input5 = null;
        _this.startResendTimer = function () {
            _this.resendTimer = setInterval(function () { return _this.tick(); }, 1000); // Update the timer every second
        };
        _this.stopResendTimer = function () {
            clearInterval(_this.resendTimer);
        };
        _this.verifyOtp = function () { return __awaiter(_this, void 0, void 0, function () {
            var verifyOtp, _a, otpValue, residentId, eventId, inputOtp, request, otpResponse;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        verifyOtp = this.props.verifyOtp;
                        _a = this.state, otpValue = _a.otpValue, residentId = _a.residentId, eventId = _a.eventId;
                        this.setState({ submitting: true, errorMsg: '', successMsg: '' });
                        inputOtp = otpValue.join('');
                        request = {
                            residentId: residentId,
                            passCode: inputOtp,
                            clientCode: '',
                            eventId: eventId
                        };
                        return [4 /*yield*/, verifyOtp(request)];
                    case 1:
                        otpResponse = _c.sent();
                        if (otpResponse !== undefined && !otpResponse.isSuccess) {
                            this.setState({ errorMsg: (_b = otpResponse.errorMessage) !== null && _b !== void 0 ? _b : 'Something went wrong. Please try again.' });
                        }
                        else if (otpResponse.isSuccess) {
                            this.setState({ errorMsg: '', isLoading: true });
                            this.signInByOtp(otpResponse.accessToken);
                        }
                        this.setState({ submitting: false, otpValue: ['', '', '', '', '', ''] });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.resendOtp = function () {
            var sendOtpToPhone = _this.props.sendOtpToPhone;
            var _a = _this.state, phoneNumber = _a.phoneNumber, residentId = _a.residentId, isPhoneEnc = _a.isPhoneEnc, eventId = _a.eventId;
            _this.setState({ isLoading: true });
            var request = {
                clientCode: '',
                phone: isPhoneEnc.length > 0 ? isPhoneEnc : phoneNumber,
                isPhoneEncrypted: isPhoneEnc.length > 0,
                residentId: residentId,
                eventId: eventId
            };
            sendOtpToPhone(request).then(function (data) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    if (data !== undefined && data.isSuccess) {
                        this.setState({ isLoading: false, resendOtpTime: 120, successMsg: 'OTP sent successfully.', errorMsg: '', otpValue: ['', '', '', '', '', ''] });
                        this.startResendTimer();
                    }
                    else {
                        this.setState({ errorMsg: 'Cannot send OTP. Please try again.', isLoading: false, successMsg: '', otpValue: ['', '', '', '', '', ''] });
                    }
                    return [2 /*return*/];
                });
            }); }).catch(function (error) {
                _this.setState({ errorMsg: 'Cannot send OTP. Please try again.', isLoading: false, successMsg: '', otpValue: ['', '', '', '', '', ''] });
            });
        };
        _this.state = defaultValue;
        return _this;
    }
    VerifyOTP.prototype.componentDidMount = function () {
        var _a;
        var data = getUrlParams();
        if (data !== undefined && data.contact !== undefined) {
            var phoneNumber = atob(data.contact);
            if (phoneNumber.length === 10) {
                this.setState({ phoneNumber: phoneNumber });
            }
        }
        if (data !== undefined && data.residentId !== undefined) {
            this.setState({ residentId: data.residentId });
        }
        if (data !== undefined && ((_a = data.isPhoneEnc) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            this.setState({ isPhoneEnc: data.isPhoneEnc });
        }
        if (data !== undefined && data.eventId !== undefined) {
            this.setState({ eventId: data.eventId });
        }
        this.setState({ resendOtpTime: 120, otpValue: ['', '', '', '', '', ''] });
        this.startResendTimer();
    };
    VerifyOTP.prototype.componentWillUnmount = function () {
        this.stopResendTimer();
    };
    VerifyOTP.prototype.tick = function () {
        var resendOtpTime = this.state.resendOtpTime;
        if (resendOtpTime !== undefined && resendOtpTime > 0) {
            this.setState({ resendOtpTime: this.state.resendOtpTime - 1 });
        }
        else {
            this.stopResendTimer();
        }
    };
    VerifyOTP.prototype.getLastInput = function (s) {
        if (s === undefined || s === '') {
            return '';
        }
        else {
            return s[s.length - 1];
        }
    };
    VerifyOTP.prototype.updateOTPValue = function (position, event) {
        var otpValue = this.state.otpValue;
        if (event.currentTarget.value !== undefined && event.currentTarget.value.length === 6) {
            var autoPopulatedOtp = event.target.value;
            this.setState({ otpValue: [autoPopulatedOtp[0], autoPopulatedOtp[1], autoPopulatedOtp[2], autoPopulatedOtp[3], autoPopulatedOtp[4], autoPopulatedOtp[5]] });
            return;
        }
        var updatedOtp = otpValue;
        updatedOtp[position] = this.getLastInput(event.currentTarget.value);
        this.setState({ otpValue: updatedOtp });
        if (updatedOtp[position] === '') {
            return;
        }
        this.handleInputFocus(position, updatedOtp[position]);
    };
    VerifyOTP.prototype.onOTPKeyDown = function (position, keyCode) {
        var otpValue = this.state.otpValue;
        if (otpValue[position] === '' && (keyCode === 8 || keyCode === 46)) {
            this.handleInputFocus(position, '');
        }
        else if (keyCode === 46) {
            var updatedOtp = otpValue;
            updatedOtp[position] = '';
            this.setState({ otpValue: updatedOtp });
        }
    };
    VerifyOTP.prototype.handleInputFocus = function (position, value) {
        if (value !== '') {
            switch (position) {
                case 0:
                    this.input1.focus();
                    break;
                case 1:
                    this.input2.focus();
                    break;
                case 2:
                    this.input3.focus();
                    break;
                case 3:
                    this.input4.focus();
                    break;
                case 4:
                    this.input5.focus();
                    break;
                default:
                    break;
            }
        }
        else {
            switch (position) {
                case 1:
                    this.input0.focus();
                    break;
                case 2:
                    this.input1.focus();
                    break;
                case 3:
                    this.input2.focus();
                    break;
                case 4:
                    this.input3.focus();
                    break;
                case 5:
                    this.input4.focus();
                    break;
                default:
                    break;
            }
        }
    };
    VerifyOTP.prototype.signInByOtp = function (accessToken) {
        var _this = this;
        var _a = this.props, signInByOtp = _a.signInByOtp, history = _a.history;
        var eventId = this.state.eventId;
        signInByOtp(accessToken, eventId)
            .then(function () {
            history.push('/');
            sendAmplitude_Otp(_this.props.residentInfo, AmplitudeEventName.OTP_Transition_Verify_Redirect_To_RSP);
        })
            .catch(function () {
            _this.setState({ errorMsg: 'Login failed due to system error. Please try again.' });
        });
    };
    VerifyOTP.prototype.render = function () {
        var _this = this;
        var form = this.props.form;
        var _a = this.state, phoneNumber = _a.phoneNumber, errorMsg = _a.errorMsg, submitting = _a.submitting, resendOtpTime = _a.resendOtpTime, isLoading = _a.isLoading, successMsg = _a.successMsg;
        return React.createElement(React.Fragment, null,
            React.createElement(Loader, { visible: isLoading, page: true }),
            React.createElement("div", { className: "login-flex" },
                React.createElement("div", { className: "login-page" },
                    React.createElement("button", { className: "navbar-toggler text-large go-back-small-screen", type: "button", onClick: function () {
                            history.back();
                            sendAmplitude_Otp(_this.props.residentInfo, AmplitudeEventName.OTP_Click_Back);
                        } },
                        React.createElement("span", { className: "iconfont icon-return", style: { fontSize: '14px' } }),
                        "Back"),
                    React.createElement("div", { className: "customer-logo" }),
                    React.createElement("div", { className: "login-box", id: "step1" },
                        React.createElement("button", { className: "navbar-toggler text-small go-back-big-screen", type: "button", onClick: function () {
                                history.back();
                                sendAmplitude_Otp(_this.props.residentInfo, AmplitudeEventName.OTP_Click_Back);
                            } },
                            React.createElement("span", { className: "iconfont icon-return", style: { fontSize: '10px' } }),
                            "Back"),
                        React.createElement("h5", { className: "text-center mt-2" },
                            "Enter the code sent to xxx-", phoneNumber === null || phoneNumber === void 0 ? void 0 :
                            phoneNumber.slice(-4),
                            "."),
                        React.createElement("div", { className: "row mt-4", style: { justifyContent: 'center' } },
                            React.createElement("input", { ref: function (dom) { return _this.input0 = dom; }, type: "text", className: "form-control otp-input", placeholder: "", maxLength: 6, autoComplete: "one-time-code", pattern: "\\d{1}", inputMode: "numeric", value: this.state.otpValue[0], onChange: function (e) { return _this.updateOTPValue(0, e); }, onKeyDown: function (e) { return _this.onOTPKeyDown(0, e.keyCode); } }),
                            React.createElement("input", { ref: function (dom) { return _this.input1 = dom; }, type: "text", className: "form-control otp-input", placeholder: "", maxLength: 6, autoComplete: "one-time-code", pattern: "\\d{1}", inputMode: "numeric", value: this.state.otpValue[1], onChange: function (e) { return _this.updateOTPValue(1, e); }, onKeyDown: function (e) { return _this.onOTPKeyDown(1, e.keyCode); } }),
                            React.createElement("input", { ref: function (dom) { return _this.input2 = dom; }, type: "text", className: "form-control otp-input", placeholder: "", maxLength: 6, autoComplete: "one-time-code", pattern: "\\d{1}", inputMode: "numeric", value: this.state.otpValue[2], onChange: function (e) { return _this.updateOTPValue(2, e); }, onKeyDown: function (e) { return _this.onOTPKeyDown(2, e.keyCode); } }),
                            React.createElement("input", { ref: function (dom) { return _this.input3 = dom; }, type: "text", className: "form-control otp-input", placeholder: "", maxLength: 6, autoComplete: "one-time-code", pattern: "\\d{1}", inputMode: "numeric", value: this.state.otpValue[3], onChange: function (e) { return _this.updateOTPValue(3, e); }, onKeyDown: function (e) { return _this.onOTPKeyDown(3, e.keyCode); } }),
                            React.createElement("input", { ref: function (dom) { return _this.input4 = dom; }, type: "text", className: "form-control otp-input", placeholder: "", maxLength: 6, autoComplete: "one-time-code", pattern: "\\d{1}", inputMode: "numeric", value: this.state.otpValue[4], onChange: function (e) { return _this.updateOTPValue(4, e); }, onKeyDown: function (e) { return _this.onOTPKeyDown(4, e.keyCode); } }),
                            React.createElement("input", { ref: function (dom) { return _this.input5 = dom; }, type: "text", className: "form-control otp-input", placeholder: "", maxLength: 6, autoComplete: "one-time-code", pattern: "\\d{1}", inputMode: "numeric", value: this.state.otpValue[5], onChange: function (e) { return _this.updateOTPValue(5, e); }, onKeyDown: function (e) { return _this.onOTPKeyDown(5, e.keyCode); } })),
                        React.createElement("div", { className: "panel-body" },
                            errorMsg && React.createElement("p", { style: { marginTop: '-1rem' } },
                                React.createElement("i", { className: "help-block text-danger" }, errorMsg)),
                            successMsg && React.createElement("p", { style: { marginTop: '-1rem' } },
                                React.createElement("i", { className: "help-block text-success" }, successMsg)),
                            React.createElement("a", { href: "javascript:void(0)", className: classnames("btn btn-submit btn-block", (this.state.otpValue.join('').trim().length < 6 || submitting) && 'disabled'), id: "verifyOtp", onClick: function () {
                                    _this.verifyOtp();
                                    sendAmplitude_Otp(_this.props.residentInfo, AmplitudeEventName.OTP_Click_Verify);
                                } }, "Verify"),
                            React.createElement("div", { className: "form-group", style: { textAlign: 'center', marginTop: '5%' } },
                                React.createElement("a", { onClick: function () {
                                        _this.resendOtp();
                                        sendAmplitude_Otp(_this.props.residentInfo, AmplitudeEventName.OTP_Click_NewCode);
                                    }, className: resendOtpTime === 0 ? "resendOtpTime" : "resendOtpTimeInactive" }, "Has your code expired? Request a new code"),
                                React.createElement("label", { hidden: resendOtpTime === 0 },
                                    " ",
                                    resendOtpTime,
                                    "s")))),
                    React.createElement("p", { className: "text-muted text-center" },
                        "\u00A9 ",
                        moment().utc().year(),
                        " Lessen, LLC. All Rights Reserved."))));
    };
    VerifyOTP = __decorate([
        createForm(),
        inject(AccountBusiness),
        observer
    ], VerifyOTP);
    return VerifyOTP;
}(React.Component));
export default VerifyOTP;
